import { UserCircleIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

interface UserIconProps {
  googleAvatarUrl?: string;
}

export const UserIcon = ({ googleAvatarUrl = undefined }: UserIconProps) => {
  const [avatarError, setAvatarError] = useState(false);

  const handleOnImageError = () => {
    setAvatarError(true);
  };

  if (googleAvatarUrl && !avatarError) {
    return (
      <img
        className="rounded-full"
        src={googleAvatarUrl}
        alt="avatar"
        onError={handleOnImageError}
      />
    );
  }

  return <UserCircleIcon />;
};
